<template>
  <v-card style="height: 120%" class="rounded-lg pa-3">
    <v-card-title
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 35px;
        font-weight: bold;
        color: #05523e;
        padding-top: 20px;
      "
    >
      Delete Employee
    </v-card-title>

    <div style="text-align: center; font-size: 18px">
      <div class="texts">
        Are you absolutely sure to delete the account below? Your account will
        not be deleted in pos.
      </div>
      <div id="deleteId">{{ userId }}</div>
    </div>
    <v-card-actions style="justify-content: center">
      <v-btn
        class="action elevation-5"
        color="#ffffff"
        style="
          color: #05523e;
          max-width: 120px;
          min-width: 100px;
          font-size: 15px;
          font-weight: bold;
          height: 35px;
          margin: 12px;
        "
        @click="$store.commit('common/changeDeleteEmployeeModalView')"
        >Cancle</v-btn
      >
      <v-btn
        class="action white--text elevation-5"
        color="#05523E"
        style="
          max-width: 120px;
          min-width: 100px;
          font-size: 15px;
          font-weight: bold;
          height: 35px;
          margin: 12px;
        "
        @click="DeleteAdmin"
        >Delete</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { runGqlMutation } from "@/graphql/gqlUtil.js";
import { DELETEADMIN } from "@/graphql/AccountMutations.js";

export default {
  props: ["propId", "userId"],
  methods: {
    async DeleteAdmin() {
      try {
        const updateResult = await runGqlMutation(DELETEADMIN, {
          _id: this.propId,
        });

        if (
          updateResult.message == undefined &&
          updateResult.deleteAdmin.ResultCount !== 0
        ) {
          await this.$emit("getEmployeeList");
          this.$store.commit("common/snackOn", {
            text: "Delete Employee Success!",
          });
          this.$store.commit("common/changeDeleteEmployeeModalView");
        } else {
          this.$store.commit("common/snackErrOn", {
            text: "Delete Employee Fail!",
          });
        }
      } catch (error) {
        console.err(error);
      }
    },
  },
};
</script>

<style scoped>
.texts {
  margin: 15px 20px;
}
#deleteId {
  color: #22a885;
  font-size: 27px;
  font-weight: 600;
  margin: 10px;
}
</style>
